// src/modules/financials/api.js
import API from '../../services/api';

/**
 * Fetch the unified financial dashboard payload.
 *
 * @param {Object}  opts
 * @param {string}  [opts.preset]    - 'today' | 'week' | 'month' | 'quarter'
 * @param {string}  [opts.startDate] - ISO date string (overrides preset)
 * @param {string}  [opts.endDate]   - ISO date string
 * @param {string}  [opts.branch]    - branch ObjectId or 'all'
 */
export const fetchFinancialDashboard = async ({ preset, startDate, endDate, branch } = {}) => {
  const params = {};
  if (preset) params.preset = preset;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (branch && branch !== 'all') params.branch = branch;

  const response = await API.get('/financials/dashboard', { params });
  return response.data;
};
